import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0dc9d1cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ion-align-items-center ion-justify-content-center call-track"
};
const _hoisted_2 = {
  key: 0,
  class: "ion-align-items-center ion-justify-content-center call-track"
};
import { useDraggable } from '@vueuse/core';
import { computed, onMounted, ref, watch } from 'vue';
import Router, { VIDEO_CALL_PATH } from '@/router';
import useCall from '@/composables/global/use-call';
import useResponsiveness from '@/composables/global/use-responsiveness';
import useViewer from '@/composables/global/use-viewer';
import { getAvatar } from '@/utils/avatar';
import { getComputedStyleValue } from '@/utils/style';
const edgePadding = 8;
export default /*#__PURE__*/_defineComponent({
  __name: 'DraggableVideo',
  setup(__props) {
    var _viewer$value;
    /**
     * TODO: fix type errors
     */
    const {
      chatId,
      chatMemberId,
      callKind,
      screenSharing,
      screenSharingVideoTrackElement,
      hasRemoteTrack,
      isCallAnswered,
      localVideoTrackElement,
      recordingRequest,
      remoteVideoTrackElement,
      setIsCallPageOpenedByUser
    } = useCall();
    const {
      windowHeight,
      windowWidth
    } = useResponsiveness();
    const {
      viewer
    } = useViewer();
    const localTrackPipRef = ref();
    const remoteTrackPipRef = ref();
    const screenSharingRef = ref();
    const avatarImgRef = ref();
    const pipTrackHeight = getComputedStyleValue(document.documentElement, '--pip-track-height');
    const pipTrackWidth = getComputedStyleValue(document.documentElement, '--pip-track-width');
    const safeTop = getComputedStyleValue(document.documentElement, '--safe-area-top');
    const safeBottom = getComputedStyleValue(document.documentElement, '--safe-area-bottom');
    const isViewerScreenSharing = screenSharing.value && screenSharing.value.by === ((_viewer$value = viewer.value) === null || _viewer$value === void 0 ? void 0 : _viewer$value.id);
    const draggableElementRef = ref();
    // Boundary restrictions
    const minX = ref(edgePadding);
    const maxX = computed(() => windowWidth.value - pipTrackWidth - edgePadding);
    const minY = ref(edgePadding + safeBottom);
    const maxY = computed(() => windowHeight.value - pipTrackHeight * (isViewerScreenSharing ? 1 : 2) - edgePadding - safeTop);
    function checkBoundaries(position) {
      if (draggableElementRef.value === undefined) return;
      const midX = (maxX.value - minX.value) / 2;
      const midY = (maxY.value - minY.value) / 2;
      const boundedX = position.x < midX ? minX.value : maxX.value;
      const boundedY = position.y < midY ? minY.value : maxY.value;
      // Update the draggable element's position
      draggableElementRef.value.style.left = `${boundedX}px`;
      draggableElementRef.value.style.top = `${boundedY}px`;
    }
    const {
      style,
      position
    } = useDraggable(draggableElementRef, {
      initialValue: {
        x: maxX.value,
        y: maxY.value
      },
      preventDefault: true,
      onEnd: checkBoundaries
    });
    function useFallbackAvatar() {
      avatarImgRef.value.$el.src = '/assets/shared/image/avatar.svg';
    }
    async function navToCallPage() {
      setIsCallPageOpenedByUser(true);
      Router.push({
        path: `${VIDEO_CALL_PATH}/${chatMemberId.value}/${chatId.value}/${callKind.value}`
      });
    }
    onMounted(() => {
      if (localVideoTrackElement.value) localTrackPipRef.value.appendChild(localVideoTrackElement.value);
      if (remoteVideoTrackElement.value) remoteTrackPipRef.value.appendChild(remoteVideoTrackElement.value);
      if (screenSharingVideoTrackElement.value && screenSharingRef.value) screenSharingRef.value.appendChild(screenSharingVideoTrackElement.value);
    });
    watch(() => [localVideoTrackElement.value, remoteVideoTrackElement.value, screenSharingVideoTrackElement.value, screenSharing.value], () => {
      if (localVideoTrackElement.value) localTrackPipRef.value.appendChild(localVideoTrackElement.value);
      if (remoteVideoTrackElement.value) remoteTrackPipRef.value.appendChild(remoteVideoTrackElement.value);
      if (screenSharingVideoTrackElement.value && screenSharingRef.value) {
        screenSharingRef.value.appendChild(screenSharingVideoTrackElement.value);
      }
    });
    watch([windowHeight, windowWidth], () => checkBoundaries(position.value), {
      flush: 'post'
    });
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_grid = _resolveComponent("ion-grid");
      const _component_ion_img = _resolveComponent("ion-img");
      const _component_ion_avatar = _resolveComponent("ion-avatar");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "draggableElementRef",
        ref: draggableElementRef,
        class: "draggable",
        style: _normalizeStyle(_unref(style))
      }, [_unref(screenSharing) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "screenSharingRef",
        ref: screenSharingRef,
        class: _normalizeClass({
          'track-container': !_unref(isViewerScreenSharing)
        })
      }, [_createVNode(_component_ion_grid, {
        class: "top-actions ion-no-padding"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_row, null, {
          default: _withCtx(() => [_createVNode(_component_ion_col, null, {
            default: _withCtx(() => [_createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = $event => navToCallPage())
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  color: "menu-icon",
                  slot: "icon-only",
                  icon: "scan"
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(recordingRequest) ? (_openBlock(), _createBlock(_component_ion_col, {
            key: 0,
            class: "ion-padding recording-signal"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_icon, {
              name: "radio-button-on",
              color: "danger"
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
        ref_key: "localTrackPipRef",
        ref: localTrackPipRef,
        class: "track-container"
      }, [_createVNode(_component_ion_grid, {
        class: "top-actions ion-no-padding"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_row, null, {
          default: _withCtx(() => [_createVNode(_component_ion_col, null, {
            default: _withCtx(() => [_createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: _cache[1] || (_cache[1] = $event => navToCallPage())
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  color: "menu-icon",
                  slot: "icon-only",
                  icon: "scan"
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(recordingRequest) && _unref(isCallAnswered) ? (_openBlock(), _createBlock(_component_ion_col, {
            key: 0,
            class: "ion-padding recording-signal"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_icon, {
              name: "radio-button-on",
              color: "danger"
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _unref(callKind) === 'audio' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ion_avatar, {
        slot: "start",
        style: {
          "position": "relative"
        }
      }, {
        default: _withCtx(() => {
          var _unref2, _unref3;
          return [_createVNode(_component_ion_img, {
            ref_key: "avatarImgRef",
            ref: avatarImgRef,
            src: _unref(getAvatar)(((_unref2 = _unref(viewer)) === null || _unref2 === void 0 ? void 0 : _unref2.displayName) || ((_unref3 = _unref(viewer)) === null || _unref3 === void 0 ? void 0 : _unref3.name)),
            onIonError: useFallbackAvatar
          }, null, 8, ["src"]), _createVNode(_component_ion_icon, {
            id: "badge",
            name: "ellipse"
          })];
        }),
        _: 1
      })])) : _createCommentVNode("", true)], 512), [[_vShow, !_unref(screenSharing)]]), _createElementVNode("div", {
        ref_key: "remoteTrackPipRef",
        ref: remoteTrackPipRef,
        class: "track-container"
      }, [!_unref(hasRemoteTrack) || _unref(callKind) === 'audio' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_ion_avatar, {
        slot: "start",
        style: {
          "position": "relative"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_img, {
          ref_key: "avatarImgRef",
          ref: avatarImgRef,
          src: _unref(getAvatar)(),
          onIonError: useFallbackAvatar
        }, null, 8, ["src"]), _unref(hasRemoteTrack) ? (_openBlock(), _createBlock(_component_ion_icon, {
          key: 0,
          id: "badge",
          name: "ellipse"
        })) : _createCommentVNode("", true)]),
        _: 1
      })])) : _createCommentVNode("", true)], 512)], 4);
    };
  }
});